import React from "react";
import classNames from "classnames";

interface Props {
  size?: string;
  solid?: boolean;
  color?: string;
}

const Loader: React.FC<Props> = ({ size, solid, color = "white" }: Props): JSX.Element => {
  const boxClass = classNames("caprx-loader-inner-box", `caprx-loader-inner-box-${color}`, { "caprx-loader-inner-box-solid": solid });

  const innerBoxes = [...Array(4)].map((_span, i) => {
    return <span key={i} className={boxClass}></span>;
  });

  const loaderStyle = {
    minWidth: size,
    minHeight: size,
    width: size,
    height: size,
  };

  return (
    <span className="caprx-loader-container" style={loaderStyle}>
      <div className="caprx-loader">{innerBoxes}</div>
    </span>
  );
};

export default Loader;
